import client from './client'
import headerAuthorization from './headerAuthorization'

const uploadFileService = {}

uploadFileService.upload = function (formData, token) {
  return client.post(
    'cargar_certificado',
    formData,
    headerAuthorization(token)
  )
    .then(res => {
      return res
    })
    .catch(error => {
      return error
    })
}

export default uploadFileService